const FILENAME_EXT_REGEX = /\.[\da-z]{1,5}$/i;

type Options = {
    showFilenameExtension: boolean;
    text: string;
};

const useFilenameExtension = ({
    showFilenameExtension,
    text: originalText,
}: Options) => {
    let text = originalText;
    let suffix = '';

    if (showFilenameExtension) {
        text = originalText.replace(FILENAME_EXT_REGEX, '');
        suffix = originalText.match(FILENAME_EXT_REGEX)?.[0] || '';
    }

    return {suffix, text};
};

export default useFilenameExtension;
